import type {
  FeatureFlagConfig,
  FeatureType,
} from '@seek/candidate-feature-flag';

export const TOGGLE_CAREER_HUB_WEB = 'toggle-career-hub-web';
const careerHubWebFeatureFlag = {
  key: TOGGLE_CAREER_HUB_WEB,
  title: 'Feature Toggle: Career Hub Web',
  type: 'boolean',
} satisfies FeatureFlagConfig;
export type CareerHubWebFeatureFlag = FeatureType<
  typeof careerHubWebFeatureFlag
>;

export const launchDarklyFeatureFlags: FeatureFlagConfig[] = [];
